import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import subscriptionsService from 'v2/services/subscriptions';

import { useStyles } from './styles';

const Export = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState<boolean>(false);

  const [totalItems] = useObservable(() => subscriptionsService.getTotalItems(), []);

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);

    return subscriptionsService.export().pipe(
      tap((data) => {
        try {
          const dateExport = moment(new Date()).format('DD-MM-YYYY');
          let fileExport = new Blob([data as any], { type: 'text/csv; charset=utf-8' });
          saveAs(fileExport, `meus-contratos-${dateExport}.csv`);
          setLoading(false);
        } catch (e) {
          console.log(e);
        } finally {
          setLoading(false);
        }
      })
    );
  }, []);

  return (
    <PermissionHide action='myeduzz:meus-contratos:exportar'>
      <Button
        id='export-report-button'
        className={classes.exportBtn}
        onClick={exportReport}
        variant='text'
        disabled={!totalItems || loading}
        startIcon={loading ? <CircularProgress size={20} color='inherit' /> : <SystemUpdateAltIcon />}
      >
        {!loading ? 'Exportar' : 'Exportando...'}
      </Button>
    </PermissionHide>
  );
};

export default Export;
